/*
 * Copyright (c) 2023 by N-Ach (Pvt) Ltd
 *
 * ╔═╗ ╔╗    ╔═══╗  ╔╗
 * ║║╚╗║║    ║╔═╗║  ║║
 * ║╔╗╚╝║    ║║ ║╠══╣╚═╗
 * ║║╚╗║║╔══╗║╚═╝║╔═╣╔╗║
 * ║║ ║║║╚══╝║╔═╗║╚═╣║║║
 * ╚╝ ╚═╝    ╚╝ ╚╩══╩╝╚╝
 *
 * All rights reserved.
 *
 * This software is the confidential and proprietary information
 * of N-Ach (Pvt) Ltd. You shall not disclose such Confidential
 * Information and shall use it only in accordance with the terms
 * of the license agreement you entered into with N-Ach (Pvt) Ltd.
 *
 *
 * @Author Dilhari Jayathunga
 * @Date 22/11/2023
 */

import { Close } from '@mui/icons-material'
import { Button, Dialog, DialogContent, IconButton, Typography } from '@mui/material'
import React, { useState } from 'react'
import styles from './LocationDialog.module.css'
import MapComponent from './MapComponent'

const LocationDialog = ({ open, onClose, location, setLocation }) => {

    const [disabled, setDisabled] = useState(true)

    const updateLocation = (coord) => {
        const { latLng } = coord;
        const lat = latLng.lat();
        const lng = latLng.lng();
        setLocation({lat: lat, lng: lng})
    }

    return (
        <Dialog
            fullWidth
            maxWidth="sm"
            open={open}
            onClose={onClose}
            aria-labelledby="location-dialog"
        >
            <DialogContent>
                <div className={styles.headingContainer}>
                    <Typography fontWeight={600} variant={"h6"}>
                        Select Location
                    </Typography>
                    {/* <IconButton className={styles.closeButton} onClick={onClose}>
                        <Close />
                    </IconButton> */}
                </div>
                <div>
                    <MapComponent
                        getLocation={(coord) => updateLocation(coord)}
                        setDisabled={setDisabled}
                    />
                </div>
                <Button fullWidth disabled={disabled} onClick={onClose} className={styles.button} variant="contained">Set Location</Button>
            </DialogContent>
        </Dialog>
    )
}

export default LocationDialog